import { Link } from 'react-router-dom';
import Empty from '../components/Empty';

export default function NotFoundPage() {
  return (
    <section className="content-page">
      <Empty
        icon="search"
        title="Page not found"
        body="The page you opened doesn't exist."
        action={
          <Link className="primary-button" to="/">
            Back to home
          </Link>
        }
      />
    </section>
  );
}
